import { createContext } from 'react';

import type {
  ColorPalette,
  CustomColorPalette,
} from '../../core/types/color-palette.js';

export const SankeyColorPaletteContext = createContext<
  ColorPalette | CustomColorPalette
>('categorical');

SankeyColorPaletteContext['displayName'] = 'SankeyColorPaletteContext';
